<template>
  <div class="text-area" :class="{portrait: portrait}">
    <div v-if="artist">
      <div class="like-h3">
        <like-box :imageId="image.image_id" />
        <h3><ix-router-link :to="pfurl">{{ artist.formatted_name }}</ix-router-link></h3>
      </div>
      <div class="tag-panel">
        <gallery-tag v-for="gallery in image.galleries" :key="gallery" :url="gallery" v-on:closing="handleClosing" />
        <div class="tag region" v-on:click.stop="changeRegion(artist.region)">{{ artist.region }}</div>
      </div>
      <div class="space-div"></div>
      <template v-if="inpage">
        <h1 class="img-desc">
          {{ image.detail.title }}
        </h1>
      </template>
      <template v-else>
        <div class="img-desc">
          {{ image.detail.title }}
        </div>
      </template>
      <div class="img-details">
        <div v-if="image.detail.medium">
          {{ $nippets.portfolio.medium }}: {{ image.detail.medium}}
        </div>
        <div v-if="image.detail.client">
          {{ $nippets.portfolio.client }}: {{ image.detail.client}}
        </div>
        <template v-if="inpage">
          <h2>
            {{ $k.spacesAfterCommas(image.detail.description) }}
          </h2>
        </template>
        <template v-else>
          <div>
            {{ $k.spacesAfterCommas(image.detail.description) }}
          </div>
        </template>
      </div>
      <div class="social-panel">
        <social-panel :url="url" :media="media" :message="message" :caption="artist.formatted_name" />
        <a class="download-button" :href="downloadLink" :download="downloadName" title="Download" v-show="!image.animation" v-on:click.stop.prevent="download"></a>
      </div>
      <div class="keyword-panel">
        <div class="img-desc space-bel">
          {{ $nippets.keywords }}
        </div>
        <keyword-tag :keyword="item" v-for="item in image.keys" :key="item"></keyword-tag>
      </div>
      <div class="about-panel" v-if="inpage">
        <div class="img-desc space-bel">
          About {{ firstName }}
        </div>
        <div class="img-details" v-html="details.overview">
        </div>
        <div class="ftast">
          <ix-router-link :to="pfurl">{{ $nippets.seefullprofile }} &gt;</ix-router-link>
        </div>
      </div>
    </div>
    <div class="mobile-only">
      <div class="font-med">{{ $nippets.portfolio.wantToDiscuss }}</div>
      <div class="bot-panel">
        <email-and-call :artist="artist" />
      </div>
    </div>
  </div>
</template>

<script>
import EmailAndCall from '@/components/panels/EmailAndCall.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import GalleryTag from '@/components/buttons/GalleryTag.vue'
import KeywordTag from '@/components/buttons/KeywordTag.vue'
import SocialPanel from '@/components/panels/SocialPanel.vue'
import axios from 'axios'

export default {
  components: {
    EmailAndCall,
    LikeBox,
    GalleryTag,
    SocialPanel,
    KeywordTag
  },
  props:{
    artist: Object,
    image: Object,
    inpage: Boolean
  },
  data () {
    return {
      portrait: false,
      details: {}
    }
  },
  mounted () {
    this.portrait = (window.innerWidth < window.innerHeight)
    
  },
  computed: {
    downloadLink () {
      if(this.image && this.image.url){
        return this.$k.getZoomImage(this.image.url)
      }
      return ''
    },
    downloadName () {
      if(this.image && this.image.url){
        let strs = this.image.url.split('/')
        return strs.pop()
      }
      return ''
    },
    message: function () {
      if(this.image && this.artist) {
        if(this.image.detail.description) return this.image.detail.description
        return this.artist.formatted_name
      }
      return ''
    },
    media: function () {
      if(this.image && this.image.url){
        return this.$k.getImage500(this.image.url)
      }
      return ''
    },
    url: function () {
      if(this.image && this.image.url){
        return this.$k.getImagePermalink(this.image, this.artist)
      }
      return ''
    },
    pfurl: function () {
      if(this.artist.animation && this.image.animation){
        return '/animators/' + this.artist.portfolio_url
      }
      return '/artists/' + this.artist.portfolio_url
    },
    firstName: function () {
      if(this.artist.formatted_name) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    }
  },
  
  methods: {
    async loadDetails () {
      this.details = await this.$k.getArtistDetails(this.artist)
    },
    handleClosing() {
      console.log('closing')
      this.$emit('closing')
    }, 
    changeRegion: function (region) {
      this.$store.dispatch('goRegion', region)
    },
    toDataURL(url) {
      return axios.get(url, { responseType: 'blob'}).then((response) => {
          return new Blob([response.data])
      }).then(blob => {
          return URL.createObjectURL(blob);
      });
    },
    async download() {
      const a = document.createElement("a");
      a.href = await this.toDataURL(this.downloadLink);
      a.download = this.downloadName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  watch: {
    artist: function () {
      if(this.artist && this.inpage) {
        this.loadDetails()
      }
    }
  }
}
</script>

<style scoped>
h3{
  font-size:28px;
  font-weight:500;
  margin:10px 0 4px 0;
}

h3 a{
  text-decoration: none;
  color:#000;
}

h3 a:hover{
  color:#ce0e2d;
}

.social-panel{
  margin-top: 50px;
  margin-bottom: 16px;
  display:flex;
}

.bot-panel{
  padding:10px 0 30px 0;
}

.img-desc{
  font-size:21px;
  overflow-wrap: break-word;
}

.text-area h1{
  line-height:normal;
  font-weight:normal;
  margin:0;
  width:auto;
}


.img-details{
  font-size:17px;
  color:#6d6d64;
}

.img-details div{
  margin:5px 0;
  overflow-wrap: break-word;
}

.text-area{
  width:20vw;
  margin-left:20px;
  box-sizing:border-box;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
}

.text-area.portrait{
  margin-left:0;
}

a.download-button{
  display:inline-block;
  background-image:url('../../assets/img/downloads.svg');
  width:21px;
  height:21px;
  cursor:pointer;
}

a.download-button:hover{
  background-image:url('../../assets/img/downloads-red.svg');
}

.like-h3{
  margin-bottom:10px;
}

.space-div{
  margin-bottom:10px;
}

.space-bel{
  margin-bottom:10px;
}

.about-panel{
  margin-top:30px;
}

.ftast{
  margin-top:10px;
}

.ftast a{
  color:#ce0e2d;
}

.img-details h2{
  font-size: 17px;
  color:#6d6d64;
  line-height:normal;
  margin:0;
  font-weight:normal;
}

@media screen and (max-width:960px){
  .text-area{
    flex-direction:row;
    width:100%;
    box-sizing:border-box;
  }

  .mobile-only{
    display:none;
  }

  .like-h3{
    display:flex;
    padding-top:16px;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
}
</style>
